module.exports = __webpack_public_path__ + "img/caap-primary-photo.7653e044.jpeg";